import type { ChainData, ChainId } from '$lib/models'
import * as m from '$lib/paraglide/messages'
import type { MaxTpsState } from '$lib/tanstack-table/max-tps-state-feature'

export const getTotalTxnsTooltipContent = (chain: ChainData) => {
	if (chain.txns == null || chain.tps === null) {
		return null
	}

	if (chain.id === 'icp_chain') {
		return m.icp_chain_tps_explanation()
	}

	return m.tooltip_total_txns_text({
		explanation: m[`${chain.id}_tps_explanation`](),
		start: chain.tps?.start.toLocaleString('en-US'),
		finish: chain.tps?.finish.toLocaleString('en-US'),
	})
}

export const getTpsTooltipContent = (chain: ChainData) => {
	if (chain.tps?.value == null) {
		return null
	}

	if (chain.id === 'icp_chain') {
		return m.icp_chain_tps_explanation()
	}

	return m.tooltip_tps_text({
		explanation: m[`${chain.id}_tps_explanation`](),
		start: chain.tps?.start.toLocaleString('en-US'),
		finish: chain.tps?.finish.toLocaleString('en-US'),
	})
}

export const isChainWithSpecialOneBlockMaxTps = (
	chainId: ChainId
): chainId is
	| 'bitcoin_chain'
	| 'ethereum_chain'
	| 'cardano_chain'
	| 'starknet_chain'
	| 'waterfall_chain'
	| 'scroll_chain'
	| 'ecash_chain' =>
	chainId === 'bitcoin_chain' ||
	chainId === 'ethereum_chain' ||
	chainId === 'cardano_chain' ||
	chainId === 'starknet_chain' ||
	chainId === 'waterfall_chain' ||
	chainId === 'scroll_chain' ||
	chainId === 'ecash_chain'

export const getMaxTpsTooltipContent = (chain: ChainData, state: MaxTpsState) => {
	if (chain.maxTps?.value == null) {
		return null
	}

	if (chain.id === 'icp_chain') {
		return m.icp_chain_tps_explanation()
	}

	if (state === 'hundred-blocks') {
		return m.tooltip_max_tps_hundred_blocks_text({
			explanation: m[`${chain.id}_tps_explanation`](),
			start: chain.maxTps?.start.toLocaleString('en-US') ?? '',
			finish: chain.maxTps?.finish.toLocaleString('en-US') ?? '',
		})
	}

	if (state === 'one-block') {
		return m.tooltip_max_tps_one_block_text({
			explanation: isChainWithSpecialOneBlockMaxTps(chain.id)
				? m[`${chain.id}_max_tps_explanation`]()
				: m[`${chain.id}_tps_explanation`](),
			block: chain.maxTpsOneBlock?.block.toLocaleString('en-US') ?? '',
		})
	}

	return null
}
